import { render, staticRenderFns } from "./inedx.vue?vue&type=template&id=196ae412&scoped=true&"
import script from "./inedx.vue?vue&type=script&lang=js&"
export * from "./inedx.vue?vue&type=script&lang=js&"
import style0 from "./inedx.vue?vue&type=style&index=0&id=196ae412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ae412",
  null
  
)

component.options.__file = "inedx.vue"
export default component.exports